module.exports = __webpack_public_path__ + "public/img/dev-bg.f408576e.gif";